export default __webpack_public_path__ + "static/media/logo_pagbank.d9c15299.png";